import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Polling de contador agregado de la Bandeja de Aprobaciones.
 * Refresca cada 60s y al volver a foco. Devuelve los counts por tipo + total.
 */
export function useAprobacionesPendientes() {
  const { user } = useAuth();
  const [counts, setCounts] = useState({ oc_vb: 0, requisicion: 0, parte_vb: 0, proforma: 0, total: 0 });

  const fetchCounts = useCallback(async () => {
    if (!user) return;
    try {
      const res = await api.get('/aprobaciones/count');
      setCounts(res.data?.counts || { oc_vb: 0, requisicion: 0, parte_vb: 0, proforma: 0, total: 0 });
    } catch {
      setCounts({ oc_vb: 0, requisicion: 0, parte_vb: 0, proforma: 0, total: 0 });
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    fetchCounts();
    const interval = setInterval(fetchCounts, 60000);
    const onFocus = () => fetchCounts();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [user, fetchCounts]);

  return counts;
}
